/*
  Demande de devis : ouverture de la fenêtre <dialog>, réouverture après envoi
  (Shopify recharge la page avec #id-du-formulaire), pré-remplissage ?ref= sur la page Devis.
  Sans JavaScript, le bouton mène à la page Devis : rien n'est bloquant.
*/
(function () {
  function ouvrir(dialog) {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    dialog.showModal();
    var champ = dialog.querySelector('[data-tsi-devis-envoye], input:not([type="hidden"]), select, textarea');
    if (champ) champ.focus();
    return true;
  }

  document.addEventListener('click', function (event) {
    var bouton = event.target.closest('[data-tsi-devis-ouvrir]');
    if (bouton) {
      if (ouvrir(document.getElementById(bouton.getAttribute('data-tsi-devis-ouvrir')))) event.preventDefault();
      return;
    }
    if (event.target.closest('[data-tsi-devis-fermer]')) {
      event.target.closest('dialog').close();
      return;
    }
    // Clic sur le fond assombri : fermeture
    if (event.target.matches && event.target.matches('dialog.tsi-dialog')) event.target.close();
  });

  // Après envoi (succès ou erreur), Shopify revient sur la page avec l'ancre du formulaire
  var ancre = window.location.hash.replace('#', '');
  if (ancre) {
    var dialogs = document.querySelectorAll('dialog[data-tsi-devis-form]');
    for (var i = 0; i < dialogs.length; i++) {
      if (dialogs[i].getAttribute('data-tsi-devis-form') === ancre) {
        // Fenêtre du tiroir panier : le tiroir fermé (visibility: hidden) la rendrait
        // invisible ; on la place directement dans <body> avant de l'ouvrir
        document.body.appendChild(dialogs[i]);
        ouvrir(dialogs[i]);
      }
    }
  }

  // Page Devis : ?ref=… pré-remplit « Produit ou référence »
  var ref = new URLSearchParams(window.location.search).get('ref');
  if (ref) {
    var champs = document.querySelectorAll('[data-tsi-devis-ref]');
    for (var j = 0; j < champs.length; j++) {
      if (!champs[j].value) champs[j].value = ref.slice(0, 200);
    }
  }
})();
